import useSWR from 'swr';
import axios from 'axios';

import { getApiUrl, formatAndThrowApiError } from '@/helpers/api';

export const useCoachActivityLocations = (coachActivityId) => {
  const urlStr = `${getApiUrl()}/mega/coach-activity-location?coachActivityId=${coachActivityId}`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        formatAndThrowApiError(err);
      }
    },
    {
      dedupingInterval: 30000, // 30 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};
